









import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'user-layout-page' })
export default class UserLayoutComponent extends Vue {
  public gotoHome() {
    this.$router.push('/');
  }
}
